import { render } from "./PurchaseRmaTable.vue?vue&type=template&id=4cbfc40c&scoped=true&ts=true&lang=pug"
import script from "./PurchaseRmaTable.vue?vue&type=script&lang=ts"
export * from "./PurchaseRmaTable.vue?vue&type=script&lang=ts"

import "./PurchaseRmaTable.vue?vue&type=style&index=0&id=4cbfc40c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cbfc40c"]])

export default __exports__